<template>
  <b-row>
    <template v-for="course in courses" >
      <b-col lg="3" sm="6" :key="course.id"   @click="goToQuestions(course.id)">
        <statistic-card-horizontal
         
          icon="ServerIcon"
          color="success"
          :statistic="course.questions.length+' عدد الأسئلة '"
          :statistic-title="course.name"
        />
      </b-col>
    </template>
  </b-row>
</template>

<script>
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
import EduCoursesController from "@/Controllers/EduCoursesController";

export default {
  components: {
    StatisticCardHorizontal,
  },
  data() {
    return {
      courses: [],
    };
  },
  async created() {
    this.courses = await new EduCoursesController().EduCoursePrograms( );
    console.log(this.courses);
  },
  methods:{
    goToQuestions(id){
        this.$router.push({name:"Questions",params:{courseId:id}})
    }  
  }
};
</script>

<style>
</style>